import React, { useState, useEffect, useCallback } from "react";
import CartTotal from "../Shopingcartpage/CartTotal";
import shape from "../../assets/images/shopping-arrow.png";
import { Link, useNavigate } from "react-router-dom";
import { faPlus, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { api } from "../../Constant";

const BilingAddresspage = () => {
    const navigation = useNavigate();
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [cartUpdated, setCartUpdated] = useState([]);
    const [addressList, setAddressList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);



    // for shipping address


    const [shippingRate, setShippingRate] = useState(0);
    const [productTotal, setProductTotal] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [deliveryAvailable, setDeliveryAvailable] = useState(true);


    // ✅ Determines whether to send user_id or guest_id


    const getAddressIdentifier = useCallback(() => {
        const userId = localStorage.getItem("userId");
        const guestId = localStorage.getItem("guest_id");

        const isGuest = guestId && userId === guestId;

        if (isGuest) return { guest_id: guestId };
        if (userId) return { user_id: userId };

        return null;
    }, []);

    useEffect(() => {
        const identifier = getAddressIdentifier();

        if (!identifier) {
            setError("User or guest session not found.");
            setIsLoading(false);
            return;
        }

        const fetchData = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const [addressRes, cartRes] = await Promise.all([
                    axios.post(api + "address_list", identifier),
                    axios.post(api + "cart_list", identifier)
                ]);

                // ✅ Address Handling
                if (addressRes.data.success === "true") {
                    const addresses = addressRes.data.address || [];
                    setAddressList(addresses);

                    // ✅ find active address
                    const active = addresses.find(a => a.active_status === "Active");

                    if (active) {
                        setSelectedCardId(active.address_id);
                        setShippingRate(Number(active.shipping_rate || 0));
                    } else if (addresses.length > 0) {
                        // ✅ If no active address, make first one active
                        const firstAddressId = addresses[0].address_id;
                        setSelectedCardId(firstAddressId);
                        setShippingRate(Number(addresses[0].shipping_rate || 0));

                        try {
                            await axios.post(api + "address_active", {
                                ...identifier,
                                address_id: firstAddressId
                            });
                        } catch (err) {
                            console.error("Failed to set default active address:", err);
                        }
                    }
                } else {
                    setAddressList([]);
                }

                // ✅ Cart Handling
                if (cartRes.data.success === "true") {
                    setCartUpdated(cartRes.data.product || []);

                    // ⭐ Capture shipping & total details from API
                    // setShippingRate(cartRes.data.shipping_rate || 0);
                    setProductTotal(cartRes.data.product_total || 0);
                    setTotalAmount(cartRes.data.total_amount || 0);
                } else {
                    setCartUpdated([]);
                }


            } catch (err) {
                console.error("Data fetch error:", err);
                setError("Failed to load your information.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [getAddressIdentifier]);

    const selectCard = async (id) => {
        const identifier = getAddressIdentifier();
        if (!identifier || id === selectedCardId) return;

        setSelectedCardId(id);


        const selectedAddress = addressList.find(a => a.address_id === id);

        if (selectedAddress) {
            setShippingRate(Number(selectedAddress.shipping_rate || 0));
            setDeliveryAvailable(selectedAddress.shipping_status !== 0);
        }
        try {
            await axios.post(api + "address_active", { ...identifier, address_id: id });
        } catch (err) {
            console.error("Address selection error:", err);
        }
    };

    const handleEditClick = (e, addressId) => {
        e.stopPropagation();
        navigation(`/Billingedit/${addressId}`);
    };

    const handleRemoveAddress = async (e, addressId) => {
        e.stopPropagation();
        const identifier = getAddressIdentifier();
        if (!identifier) return;

        const originalList = [...addressList];
        setAddressList(prev => prev.filter(item => item.address_id !== addressId));

        try {
            const res = await axios.post(api + "delete_address", { ...identifier, address_id: addressId });
            if (res.data.success !== "true") {
                setAddressList(originalList);
                setError("Failed to delete address.");
            }
        } catch (err) {
            console.error("Delete error:", err);
            setAddressList(originalList);
            setError("Error deleting address.");
        }
    };

    if (isLoading) {
        return (
            <div className="loading-container pt-80 pb-80" style={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faSpinner} spin size="3x" />
                <p>Loading Your Details...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container pt-80 pb-80" style={{ textAlign: 'center', color: 'red' }}>
                <p>{error}</p>
            </div>
        );
    }


    return (
        <div className="billingpage-bg pt-40 pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-lg-12 shopping-tit-container">
                                <div className="top-success">
                                    <div className="icon"><FontAwesomeIcon icon={faCheck} /></div>
                                    <h3>SHOPPING CART</h3>
                                </div>
                                <img src={shape} alt="arrow" />
                                <h1>BILLING ADDRESS</h1>
                                <img src={shape} alt="arrow" />
                                <h3>PAYMENT DETAIL</h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="add-address-tittle">
                                    <Link to="/Billing-Address-Form" className="plus-bg">
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Link>
                                    <h5>Add New Address</h5>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            {/* {item.address_id === selectedCardId && !deliveryAvailable && (
                                        <p style={{ color: "red",  marginTop: "10px" }}>
                                            Delivery is not available for this pincode.
                                        </p>
                                    )} */}
                            {addressList.map(item => (
                                <div key={item.address_id}>

                                    {/* Show delivery warning ABOVE the selected address card */}
                                    {item.address_id === selectedCardId && !deliveryAvailable && (
                                        <p style={{ color: "red", marginBottom: "8px" }}>
                                            Delivery is not available for this pincode.
                                        </p>
                                    )}

                                    <div
                                        className={item.address_id === selectedCardId ? "selected-address-card" : "address-card"}
                                        onClick={() => selectCard(item.address_id)}
                                    >
                                        <div className="inneraddress">
                                            <h5>{item.first_name} {item.last_name}</h5>
                                            <p>{item.address}</p>
                                            <p><b>{item.phone_number}</b></p>
                                        </div>

                                        <div className="address-card-btn">
                                            <button onClick={(e) => handleRemoveAddress(e, item.address_id)}>Remove</button>
                                            <button onClick={(e) => handleEditClick(e, item.address_id)}>Edit</button>
                                        </div>
                                    </div>

                                </div>
                            ))}

                            {addressList.length === 0 && (
                                <div className="col-12">
                                    <p>You have no saved addresses. Please add one.</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-lg-4 shoping-cartscroll">
                        <CartTotal
                            cartUpdated={cartUpdated}
                            CartTotal="PROCEED TO PAY"
                            selectedAddressId={selectedCardId}
                            shippingRate={shippingRate}
                            productTotal={productTotal}
                            totalAmount={totalAmount}
                            showShipping={true}
                            deliveryAvailable={deliveryAvailable}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BilingAddresspage;
